
import PageHeader from "@/components/core/PageHeader";
import PlaceCard from "@/components/PlaceCard";
import tableLoading from "@/components/tableLoading";
import NoContent from "@/components/customer-content/NoContent";
import ExploreCard from '@/components/ExploreCard';
import ImageHeader from '@/components/core/ImageHeader';
export default {
    scrollToTop: true,
    components: {
        PageHeader,
        tableLoading,
        PlaceCard,
        NoContent,
        ExploreCard,
        ImageHeader,
    },
    head() {
        return {
            title: this.metaTitle(),
            meta: [{
                hid: "description",
                name: "description",
                content: this.metaDesc(),
            },
            {
                hid: 'keywords',
                name: 'keywords',
                content: this.metaKeywords()
            },
            {
                hid: "og:title",
                property: "og:title",
                content: this.metaTitle(),
            },
            {
                hid: "og:description",
                property: "og:description",
                content: this.metaDesc(),
            },
            {
                hid: "twitter:title",
                property: "twitter:title",
                content: this.metaTitle(),
            },
            {
                hid: "twitter:description",
                property: "twitter:description",
                content: this.metaDesc(),
            },
            {
                hid: 'image',
                property: 'image',
                content: this.metaImage()
            },
            {
                hid: 'og:image',
                property: 'og:image',
                content: this.metaImage()
            },
            {
                hid: 'og:image:secure_url',
                property: 'og:image:secure_url',
                content: this.metaImage()
            },
            ],
        };
    },

    jsonld() {
        return this.getJsonData()
    },

    data() {
        return {
            categorySlug: null,
            stateSlug: 'goa',
            pgTitle: null,
            pgDesc: null,
            skip: 0,
            page: 1,
            totalNumberOfpages: 0,
            listings: {},
            schemaData: [],
            listingLoading: true,
            busy: false,
            productObj: [],
            seoData: null
        };
    },

    async fetch() {
        let cat = this.$route.path.split("/").pop();
        this.seoData = await fetch(this.$config.fetchUrl + '/api/activityCategories/seo/getSEOContent/' + cat)
            .then(res => res.json()).catch(error => {
                console.error("There was an error!", error); return false;
            });
    },

    mounted() {
        document.body.classList.add("modalOverflow");
        if (localStorage.getItem("plcData")) {
            localStorage.removeItem('plcData');
        }
        this.categorySlug = window.location.href.split("/").pop();
        this.stateSlug = this.$route.params.state;
        this.getCatTitles(this.categorySlug)
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        let pagination = (this.page - 1) * 12;
        if (pagination < 0) {
            pagination = 0;
        }
        this.getListings(pagination);
    },

    destroyed() {
        document.body.classList.remove("modalOverflow");
        if (document.getElementById("filterClose"))
            document.getElementById("filterClose").click();
        if (document.getElementById("locationClose"))
            document.getElementById("locationClose").click();
    },

    methods: {
        metaTitle() {
            if (this.seoData && this.seoData.title) {
                const d = new Date();
                let cat = this.$route.path.split("/").pop();
                this.getCatTitles(cat)
                return `${this.pgTitle} - ${this.seoData.title} (Updated ${d.getFullYear()})`
            } else {
                return 'Goa App '
            }
        },
        metaDesc() {
            if (this.seoData && this.seoData.description) {
                return this.seoData.description
            } else {
                return 'Goa App | Discover Beaches, Churches, Dudhsagar Waterfalls Tour, Parasailing, Watersports Activities, Scuba Diving, Grand Island Tour, Car Rentals in Goa.'
            }
        },
        metaKeywords() {
            if (this.seoData && this.seoData.keywords) {
                return this.seoData.keywords;
            } else {
                return 'Goa Tourism, Travel Guide, Must do Activities, Top Activities to do in Goa, Goa, Watersports, must visit places, Must do activities, Watesports, Scuba diving, Parasailing, Kayaking, Dudhsagar Waterfalls Tour, Grand Island Goa, Cheap, Discount, Offers, Travel Goa'
            }
        },

        metaImage() {
            if (this.seoData && this.seoData.image) {
                return this.seoData.image;
            } else {
                return 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-12-14T06%3A34%3A55.402Zbeaches.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=L%2FFNG4DzwiyU1H%2BoK2pdHPxA4qkomya%2BxGZmJq2vCtr7Y4l74qnAn8Tk8Cz1mUNsV%2F7%2FEAKRpl0thh8wvSgb8vqvaA3Wk0TO%2FLp%2FRbqF5wDyixmv90TsYvNguZQAx0BmaE9W0AMQNOiVWG5AfYa2pyyyYhYO6Z3aXQ25biU1%2BjjYZ8NMto47ea4UuyC2btEEDU1IK9GivCXtxlcFDC3xEC80EbMub0mIowfGV2EQ0Nr3Dm0kOLurIx5jy%2Ba1oVAB2Eu3MzLIp%2B1Nm%2BnleN%2FaHTp5pWmj2y7VNqbjtA8wcw94Q1rL1b7FXSsHuxBmNABsdt3INpqGVpT%2BhO2G7iphbg%3D%3D'
            }
        },
        loadMore() {
            this.busy = false;
            if (this.listings.isMoreDataAvailable) {
                this.busy = true;
                setTimeout(() => {
                    this.page++
                    this.callback(this.page)
                }, 1000);
            }
        },

        getJsonData() {
            let structure = {
                "@context": "http://schema.org"
            }
            let data = this.schemaData.map((itm, index) => ({
                "@type": "LocalBusiness",
                "name": itm.post && itm.post.title ? itm.post.title : 'Goa App',
                "image": itm.post && itm.post.gallery ? itm.post.gallery : [],
                "geo": {
                    "@type": "GeoCoordinates",
                    "latitude": itm.post && itm.post.location ? itm.post.location.latitude : '',
                    "longitude": itm.post && itm.post.location ? itm.post.location.longitude : ''
                },
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": itm.post && itm.post.location ? itm.post.location.address : '',
                    "addressLocality": "Goa",
                    "postalCode": "403001",
                    "addressCountry": "IN"
                },
                priceRange: '',
                "review": {
                    "@type": "Review",
                    "reviewRating": {
                        "@type": "Rating",
                        "ratingValue": itm.post && itm.post.rating ? itm.post.rating.averageRating : '',
                        "bestRating": itm.post && itm.post.rating ? itm.post.rating.averageRating : '',
                    },
                    "author": {
                        "@type": "Person",
                        "name": "GoaApp"
                    }
                },
                "aggregateRating": {
                    "@type": "AggregateRating",
                    "ratingValue": itm.post && itm.post.rating ? itm.post.rating.averageRating : '',
                    "reviewCount": itm.post && itm.post.views ? String(itm.post.views.count).slice(0, 2) : ''
                },
            }))
            let ds = {
                "@graph": data
            }
            return {
                ...structure,
                ...ds
            };
        },

        getCatTitles(title) {
            switch (title) {
                case 'villages':
                    this.pgTitle = 'Villages/Cities in '  + this.stateSlug
                    this.pgDesc = 'Discover the charm of picturesque villages and vibrant cities around ' + this.stateSlug + ". Explore unique cultural traditions, stunning landscapes, and local attractions that offer an authentic experience."
                    break;
                case 'waterfalls':
                    this.pgTitle = 'Waterfalls in '  + this.stateSlug
                    this.pgDesc = "Discover " + this.stateSlug + " most breathtaking waterfalls, where nature's beauty cascades in stunning displays. Explore majestic falls surrounded by lush landscapes, offering serene escapes and adventurous hikes."
                    break;
                case 'religious-places':
                    this.pgTitle = 'Religious Places in '  + this.stateSlug
                    this.pgDesc = "Discover spiritual landmarks that offer insight into diverse cultures, faiths, and traditions in " + this.stateSlug + ". Perfect for those seeking spiritual enrichment, historical insights, and architectural marvels."
                    break;
                case 'forts':
                    this.pgTitle = 'Forts in '  + this.stateSlug
                    this.pgDesc = "Explore "+ this.stateSlug +" curated collection of historic forts, showcasing impressive architecture and rich cultural heritage."
                    break;
                case 'beaches':
                    this.pgTitle = 'Beaches in '  + this.stateSlug
                    this.pgDesc = "Discover " + this.stateSlug + " most beautiful beaches, where crystal-clear waters meet pristine sands. Explore serene getaways, vibrant coastal towns, and exotic islands perfect for sunbathing, water sports, and unforgettable sunsets."
                    break;
                case 'picnic-spots':
                    this.pgTitle = 'Picnic Spots in '  + this.stateSlug
                    this.pgDesc = "Find the best picnic spots in "  + this.stateSlug + " for a relaxing day with family and friends. Explore beautiful parks, gardens, and lakeside areas that are perfect for enjoying nature and fresh air. "
                    break;
                case 'farms':
                    this.pgTitle = 'Farms in '  + this.stateSlug
                    this.pgDesc = "Explore the Charm of Goa's Farms."
                    break;
                case 'hostels':
                    this.pgTitle = 'Hostels in '  + this.stateSlug
                    this.pgDesc = "Your Perfect Stay in Goa's Lively Hostel Scene"
                    break;
                case 'nightlife':
                    this.pgTitle = 'Nightlife in '  + this.stateSlug
                    this.pgDesc = "Experience the Pulse of Goa's Electric Nights!"
                    break;

                default:
                    this.pgTitle = 'Places in '  + this.stateSlug
                    this.pgDesc = 'Places in Goa'
            }
        },

        activitiesImage(image) {
            if (image.length > 0) {
                return image[0];
            } else {
                return "";
            }
        },
        // To add a fallback placeholder image if not rendereds from API
        setFallbackImageUrl(event) {
            event.target.src = require(`@/assets/img/placeholders/places.svg`);
        },

        // callback for the pagination plugin
        callback: function (page) {
            this.page = page;
            let pagination = (page - 1) * 12;
            if (pagination < 0) {
                pagination = 0;
            }
            this.getListings(pagination);
        },

        // TO get SUBSCRIPTIONS using pagination
        getListings(skip) {
            // AXIOS api call to add category api
            this.$axios
                .get(`/api/posts/app/getPlacesOfType/${this.stateSlug}/${this.categorySlug}/${skip}`)
                .then((response) => {
                    let value = this.getCryptKey(response.data);
                    this.listings = value;
                    this.productObj.push(...value.posts)
                    this.schemaData = this.listings && this.listings.posts ? this.listings.posts : [];
                    if (skip == 0) {
                        this.page = 1;
                    }
                    this.totalNumberOfpages = Math.ceil(this.listings.totalCount / 12);
                    this.$nextTick(() => {
                        this.busy = false;
                        this.listingLoading = false;
                    });
                })
                .finally(() => {
                    this.$nextTick(() => {
                        this.listingLoading = false;
                    });
                });
        },

    },
};
